export default __webpack_public_path__ + "static/media/book.98c88db8.svg";